// src/components/PromoPopup.jsx
import './style/PromoPopup.css';
import React, { useEffect, useState } from "react";

const PromoPopup = ({
  promoCode = "BEONWALL10",
  title = "🎉 Offre spéciale",
  message = "Profitez de -10% sur votre première commande avec le code ci-dessous.",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  // Le popup s'affiche à chaque arrivée sur la page
  useEffect(() => {
    setIsOpen(true);
  }, []);

  const closePopup = () => {
    setIsOpen(false);
  };

  const handleCopyAndClose = async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
      setCopied(true);
      setTimeout(() => {
        closePopup();
      }, 800);
    } catch (err) {
      console.error("Erreur lors de la copie :", err);
      closePopup();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="promo-popup-backdrop">
      <div className="promo-popup-modal">
        <button className="promo-popup-close" onClick={closePopup} aria-label="Fermer">
          ✕
        </button>

        <h2 className="promo-popup-title">{title}</h2>
        <p className="promo-popup-text">{message}</p>

        <div className="promo-popup-code-box">
          <span className="promo-popup-code">{promoCode}</span>
        </div>

        <button className="promo-popup-button" onClick={handleCopyAndClose}>
          {copied ? "Copié ✅" : "OK et copier le code"}
        </button>

        <button className="promo-popup-secondary" onClick={closePopup}>
          Continuer sans l’offre
        </button>
      </div>
    </div>
  );
};

export default PromoPopup;
